
import { createAsyncThunk } from "@reduxjs/toolkit";

import { addBillingCodeData, deleteBillingCodeData, fetchBillingCodeList, updateBillingCodeData } from "../../apis/accounting";

export const fetchBillingCodeListData = createAsyncThunk(
  "billingCodelList/fetchBillingCodeList",
  async (_, { rejectWithValue }) => {
    try {
      const billincode = await fetchBillingCodeList();
      return billincode;
    } catch (error: any) {
      console.log("error->", error);
      return rejectWithValue(error.message);
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as any; // Replace 'any' with your RootState type
      return !state.billingCodeList.isDataFetched; // Adjust path based on your state structure
    }
  }
);

export const updateBillingCode = createAsyncThunk(
  "billingCode/updateBillingCode",
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: {
        [key: string]: any;
        accountingId: string;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const result = await updateBillingCodeData(id, data);
      return result.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteBillingCode = createAsyncThunk(
  "billingCode/deleteBillingCode",
  async (
    {
      id,
    }: {
      id: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await deleteBillingCodeData(id);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addNewBillingCodeData = createAsyncThunk(
  "billingCode/addNewBillingCode",
  async (
    {
      data,
    }: {
      data: {
        [key: string]: any;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await addBillingCodeData(data);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);